import { get } from 'lodash/object'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'

Vue.use(Vuetify)

export const installVuetify = (Vue, opts) => {
  const preset = get(opts, 'vuetifyOpts.preset', {})
  const vuetify = new Vuetify({
    preset: preset,
    lang: {
      t: (key, ...params) => opts.i18n.t(key, params)
    },
    ...opts
  })
  Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'fa'
  })
  return vuetify
}
